import {TmcDefinition, TmcDefinitions, TmcLegDefinition} from "../../../models/TmcDefinition";
import {OptionRecord, OptionRecords} from "../../../../options/contracts/models/OptionChainRecord";
import {SecurityMap, SecurityMapOf} from "../../../../security/common/map/SecurityMap";
import {TmcLegModel, TmcListModel, TmcListModels} from "../internal/TmcListModel";

export function BuildModels(tmcs: TmcDefinitions, options: OptionRecords): TmcListModels {
    const optionMap = SecurityMapOf<OptionRecord>();
    options.forEach((o) => optionMap.set(o, o));

    return tmcs.map((tmc) => buildModel(tmc, optionMap))
               .sort((a, b) => a.code.localeCompare(b.code));
}

function buildModel(tmc: TmcDefinition, options: SecurityMap<OptionRecord>): TmcListModel {
    const legs = tmc.legs.map((leg) => buildLeg(leg, options));
    return {
        code: tmc.code,
        exchange: tmc.exchange,
        tmc,
        legs
    };
}

function buildLeg(leg: TmcLegDefinition, options: SecurityMap<OptionRecord>): TmcLegModel {
    const option = options.get(leg);
    return {
        code: leg.code,
        exchange: leg.exchange,
        side: leg.side,
        ratio: leg.ratio,
        type: option?.type,
        expiry: option?.expiry,
        strike: option?.strike,
        style: option?.style,
        cvf: option?.cvf,
        underlying: option?.underlying
    };
}
